<input
  [type]="type"
  class="form-control"
  [class.is-invalid]="frame.isErrorVisible"
  [id]="frame.inputId"
  [placeholder]="placeholder || frame.label"
  [formControl]="frame.control"
/>
